module.exports = __webpack_public_path__ + "static/media/2024.5a5fa98a.png";